
import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";

import App from "./App";

import reportWebVitals from "./reportWebVitals";

// ================= ROOT =================

const root = ReactDOM.createRoot(
  document.getElementById("root")
);

// ================= RENDER =================

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ================= WEB VITALS =================

reportWebVitals();
